import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import Slide from '@mui/material/Slide';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

// @mui/icons-material
import Close from '@mui/icons-material/Close';

// core components
import Button from "../components/Button.jsx";
import OthelloTituloPanelData from './OthelloTituloPanelData.jsx';

import { MessageOthelloBoxButtons, DialogOthelloResult } from "../othelloConstantes.jsx";

import { MostrarRetorno } from '../othelloFunciones.jsx';


function Transition(props) {
    return <Slide direction="down" {...props} />;
}

export default function OthelloModalBase({ ...props }) {

    const { tituloliteral, titulo, botones, textobotones, maxWidth } = props;

    const { t } = useTranslation();

    const [modal, setmodal] = useState(props.open);
    const [evento, setevento] = useState(false);
    const [retornoCResultadoOthello, setretornoCResultadoOthello] = useState(props.retornoCResultadoOthello);

    const handleClickOpen = (modal) => {
        //var x = [];
        //x[modal] = true;

        //this.setState(x);

        setmodal(true);

    }

    const handleClose = (modal, estado) => {
        if (props.autoclosebtaceptar == null || props.autoclosebtaceptar) {
            //var x = [];
            //x[modal] = false;
            //this.setState(x);
            setmodal(false);
        }

        if (props.onCloseResulModal != null)
            props.onCloseResulModal(props.modo, estado, null);

        //setevento(true)
        setretornoCResultadoOthello(null);
    }

    const getliteralboton = (t, botones, opc, textobotones) => {
        if (opc == 1) {
            if (textobotones != null && textobotones.length >= 1)
                return t != null ? t(textobotones[0]) : "Aceptar";
            else {
                if (botones == MessageOthelloBoxButtons.OK || botones == MessageOthelloBoxButtons.OKCancel)
                    return t != null ? t('_aceptar') : "Aceptar";
                else if (botones == MessageOthelloBoxButtons.YesNo || botones == MessageOthelloBoxButtons.YesNoCancel)
                    return t != null ? t('_si') : "Si";
                else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                    return t != null ? t('_abortar') : "Abortar";
                else if (botones == MessageOthelloBoxButtons.RetryCancel)
                    return t != null ? t('_retry') : "Reintentar";
            }
        }
        else if (opc == 2) {

            if (textobotones != null && textobotones.length >= 2)
                return t != null ? t(textobotones[1]) : "Aceptar";
            else {
                if (botones == MessageOthelloBoxButtons.OKCancel || botones == MessageOthelloBoxButtons.RetryCancel)
                    return t != null ? t('_cancelar') : "Cancelar";
                else if (botones == MessageOthelloBoxButtons.YesNo || botones == MessageOthelloBoxButtons.YesNoCancel)
                    return t != null ? t('_no') : "No";
                else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                    return t != null ? t('_retry') : "Reintentar";
            }
        }
        else if (opc == 3) {
            if (textobotones != null && textobotones.length >= 3)
                return t != null ? t(textobotones[2]) : "Aceptar";
            else {
                if (botones == MessageOthelloBoxButtons.YesNoCancel)
                    return t != null ? t('_cancelar') : "Cancelar";
                else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                    return t != null ? t('_ignorar') : "Ignorar";
            }
        }

        return "";
    }

    const getestado = (botones, opc) => {
        if (opc == 1) {
            if (botones == MessageOthelloBoxButtons.OK || botones == MessageOthelloBoxButtons.OKCancel)
                return DialogOthelloResult.OK;
            else if (botones == MessageOthelloBoxButtons.YesNo || botones == MessageOthelloBoxButtons.YesNoCancel)
                return DialogOthelloResult.Yes;
            else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                return DialogOthelloResult.Abort;
            else if (botones == MessageOthelloBoxButtons.RetryCancel)
                return DialogOthelloResult.Retry;
        }
        else if (opc == 2) {

            if (botones == MessageOthelloBoxButtons.OKCancel || botones == MessageOthelloBoxButtons.RetryCancel)
                return DialogOthelloResult.Cancel;
            else if (botones == MessageOthelloBoxButtons.YesNo || botones == MessageOthelloBoxButtons.YesNoCancel)
                return DialogOthelloResult.No;
            else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                return DialogOthelloResult.Retry;
        }
        else if (opc == 3) {

            if (botones == MessageOthelloBoxButtons.YesNoCancel)
                return DialogOthelloResult.Cancel;
            else if (botones == MessageOthelloBoxButtons.AbortRetryIgnore)
                return DialogOthelloResult.Ignore;
        }

        return DialogOthelloResult.None;
    }

    //Si no me viene definido los botones entonces estamos por defecto con el aceptar cancelar
    let botonesfinal = botones != null ? botones : MessageOthelloBoxButtons.OKCancel;

    let boton1 = "";
    let boton2 = "";
    let boton3 = "";

    boton1 = botones != MessageOthelloBoxButtons.None ? <Button onClick={() => handleClose("modal", getestado(botonesfinal, 1))} color="millenium">{getliteralboton(t, botonesfinal, 1, textobotones)}</Button> : "";

    //Si la opciones es distinta a la de OK, es que tenemos boton cancelar
    if (botones != MessageOthelloBoxButtons.OK && botones != MessageOthelloBoxButtons.None)
        boton2 = <Button onClick={() => handleClose("modal", getestado(botonesfinal, 2))} color="secondary" >{getliteralboton(t, botonesfinal, 2, textobotones)}</Button>

    if (botones == MessageOthelloBoxButtons.AbortRetryIgnore || botones == MessageOthelloBoxButtons.YesNoCancel)
        boton3 = <Button onClick={() => handleClose("modal", getestado(botonesfinal, 3))} color="secondary" >{getliteralboton(t, botonesfinal, 3, textobotones)}</Button>

    let showretorno = "";

    let retorno = evento ? retornoCResultadoOthello : props.retornoCResultadoOthello;

    if (retorno != null)
        showretorno = MostrarRetorno(retorno, false, props.onCloseCResulRetorno, retorno.botones, retorno.textoBotones, true);

    //Limpiamos que el cambio ha sido por el evento, por si en otro lugar se ha realizado el deshacer, o al principio, que en esos casos debe tomar el de por defecto
    //evento = false;

    return (
        <div >
            <Dialog fullWidth
                PaperProps={{
                    sx: {
                        overflow: "visible",
                    }
                }}
                maxWidth={maxWidth != null && maxWidth != "" ? maxWidth : "md"}
                open={modal}
                transition={Transition}
                keepMounted
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleClose("modal", DialogOthelloResult.Cancel)
                    }
                }}
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description"
                scroll="body" >
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                >
                    <OthelloTituloPanelData titulo={t != null && tituloliteral != null ? t(tituloliteral) : titulo} childrenentitulo={true}>
                        {
                            <Button size='small' variant="outlined" onClick={() => handleClose("modal", DialogOthelloResult.Cancel)} key="close"
                                aria-label="Close" ><Close /></Button>
                        }
                    </OthelloTituloPanelData>
                </DialogTitle>
                <DialogContent
                    id="modal-slide-description"
                >
                    {props.children}
                </DialogContent>
                <DialogActions>
                    {boton1}
                    {boton2}
                    {boton3}
                    {showretorno}
                </DialogActions>
            </Dialog>
        </div>

    );
}

OthelloModalBase.propTypes = {
    tituloliteral: PropTypes.string,
    titulo: PropTypes.string,
    open: PropTypes.bool, //Se gestioana con DataStateModal
    modo: PropTypes.object, //Constante ModoModal
    botones: PropTypes.object, //Los botones se gestionan con MessageOthelloBoxButtons
    textobotones: PropTypes.object, //Array de literales 
    autoclosebtaceptar: PropTypes.bool, //indica si se quiere que se cierra el modal automaticamente al dar al pulsar aceptar (true si no se define)
    onCloseResulModal: PropTypes.object,
    retornoCResultadoOthello: PropTypes.object,
    onCloseCResulRetorno: PropTypes.object,
    maxWidth: PropTypes.object //Las opciones xs'| 'sm' | 'md' | 'lg' | 'xl' | false| string
};



//String Resp = "";

//if (botones == MessageOthelloBoxButtons.AbortRetryIgnore || botones == MessageOthelloBoxButtons.YesNoCancel)
//    Resp = "CANCEL";
//else
//    Resp = "NO";

//foreach(IncidenciaUsuario Res in Resultado.Incidencias.Where(x => x.RespuestasUsuario == null || x.RespuestasUsuario.Equals(Resp)))
//{
//    String Msj = Res.ParamsLiteralTextoUsuario != null && Res.ParamsLiteralTextoUsuario.Length > 0 ?
//        string.Format(NSClasesOthello.PlugIn.Preferencias.Literales.TomarLiteral(Res.LiteralTextoUsuario, Res.DefaultTextoUsuario),
//            Res.ParamsLiteralTextoUsuario) :
//        NSClasesOthello.PlugIn.Preferencias.Literales.TomarLiteral(Res.LiteralTextoUsuario, Res.DefaultTextoUsuario);

//    DialogOthelloResult respuesta = MostrarRetorno(Resultado, Msj, botones, MessageBoxIcon.Question, MessageBoxDefaultButton.Button1, TextButtons);

//    bool ContinuarConInci = true;

//    //SI es de tres botones
//    if (botones == MessageOthelloBoxButtons.AbortRetryIgnore || botones == MessageOthelloBoxButtons.YesNoCancel) {
//        if (respuesta == DialogOthelloResult.Abort || respuesta == DialogOthelloResult.Yes)
//            Res.RespuestasUsuario = "SI";
//        else if (respuesta == DialogOthelloResult.Retry || respuesta == DialogOthelloResult.No)
//            Res.RespuestasUsuario = "NO";
//        else
//            Res.RespuestasUsuario = "CANCEL";

//        //si se pulso el boton de cancelar y este 
//        if (Res.RespuestasUsuario == "CANCEL" && !GestionBotonCancel)
//            ContinuarConInci = false;
//    }
//    //Si es de dos botones
//    else if (botones == MessageOthelloBoxButtons.YesNo || botones == MessageOthelloBoxButtons.OKCancel || botones == MessageOthelloBoxButtons.RetryCancel) {
//        if (respuesta == DialogOthelloResult.OK || respuesta == DialogOthelloResult.Yes || respuesta == DialogOthelloResult.Retry)
//            Res.RespuestasUsuario = "SI";
//        else
//            Res.RespuestasUsuario = "NO";

//        //si se pulso el boton de cancelar y este 
//        if (Res.RespuestasUsuario == "NO" && !GestionBotonCancel)
//            ContinuarConInci = false;
//    }
//    //Sino, es que estamos en la opcion de solo un boton, el OK
//    else
//        Res.RespuestasUsuario = "SI";

//    return ContinuarConInci;
//}